import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const DisabledDowngradeButton = ({
  size
}) => {
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "bottom right",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pricingCtas.downgradeTooltip"
    }),
    children: /*#__PURE__*/_jsx(Button, {
      disabled: true,
      block: true,
      size: size,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pricingCtas.buyNow"
      })
    })
  });
};
export default DisabledDowngradeButton;